import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import ContextProvider from "./components/ContextProvider";
import "./index.scss";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';

ReactDOM.render(
	<React.StrictMode>
		<BrowserRouter>
			<ContextProvider>
				<App />
				<ToastContainer />
			</ContextProvider>
		</BrowserRouter>
	</React.StrictMode>,
	document.getElementById("root")
);
